import { NonCustomCategories } from "@/shared/constants/fee-schedule-categories";

import { PROCEDURE_FEE_VALUE_SETS } from "./procedure-fee-value-sets";

/** Shared copy for the billing refresh control (tooltip + aria-label). */
export const REFRESH_BILLING_TABLES_LABEL = "Refresh billing tables";

/** Fee schedule ValueSet for each category. Display order follows the enum order. */
export const NON_CUSTOM_CATEGORY_VALUE_SETS: Record<NonCustomCategories, string> = {
  [NonCustomCategories.LaborAndDelivery]: PROCEDURE_FEE_VALUE_SETS.LABOR_AND_DELIVERY,
  [NonCustomCategories.OfficeVisitNewPatient]: PROCEDURE_FEE_VALUE_SETS.OFFICE_VISIT_NEW_PATIENT,
  [NonCustomCategories.OfficeVisitEstablishedPatient]:
    PROCEDURE_FEE_VALUE_SETS.OFFICE_VISIT_ESTABLISHED_PATIENT,
  [NonCustomCategories.OfficeVisitConsultation]: PROCEDURE_FEE_VALUE_SETS.OFFICE_VISIT_CONSULTATION,
  [NonCustomCategories.HomeVisitNewPatient]: PROCEDURE_FEE_VALUE_SETS.HOME_VISIT_NEW_PATIENT,
  [NonCustomCategories.HomeVisitEstablishedPatient]:
    PROCEDURE_FEE_VALUE_SETS.HOME_VISIT_ESTABLISHED_PATIENT,
  [NonCustomCategories.ProlongedServices]: PROCEDURE_FEE_VALUE_SETS.PROLONGED_SERVICES,
  [NonCustomCategories.FetalTestingAndUltrasound]:
    PROCEDURE_FEE_VALUE_SETS.FETAL_TESTING_AND_ULTRASOUND,
  [NonCustomCategories.PreventiveVisitNewPatient]:
    PROCEDURE_FEE_VALUE_SETS.PREVENTIVE_VISIT_NEW_PATIENT,
  [NonCustomCategories.PreventiveVisitEstablishedPatient]:
    PROCEDURE_FEE_VALUE_SETS.PREVENTIVE_VISIT_ESTABLISHED_PATIENT,
  [NonCustomCategories.GynecologyAndContraception]:
    PROCEDURE_FEE_VALUE_SETS.GYNECOLOGY_AND_CONTRACEPTION,
  [NonCustomCategories.NewbornPediatricCare]: PROCEDURE_FEE_VALUE_SETS.NEWBORN_PEDIATRIC_CARE,
  [NonCustomCategories.MedicationsCathetersIVOxygen]:
    PROCEDURE_FEE_VALUE_SETS.MEDICATIONS_CATHETERS_IV_OXYGEN,
  [NonCustomCategories.OtherProceduresAndServices]:
    PROCEDURE_FEE_VALUE_SETS.OTHER_PROCEDURES_AND_SERVICES,
  [NonCustomCategories.FacilityFee]: PROCEDURE_FEE_VALUE_SETS.FACILITY_FEE,
  [NonCustomCategories.ScreeningCounseling]: PROCEDURE_FEE_VALUE_SETS.SCREENING_COUNSELING,
  [NonCustomCategories.TelehealthVisits]: PROCEDURE_FEE_VALUE_SETS.TELEHEALTH_VISITS,
};

export const TABLE_MIN_WIDTH = 900;

export type ProcedureColumnKey =
  | "status"
  | "code"
  | "name"
  | "insuranceFee"
  | "selfPayFee"
  | "action";

interface ProcedureColumn {
  key: ProcedureColumnKey;
  label: string;
  colSpan: number;
  align?: "left" | "right";
}

export const PROCEDURE_COLUMNS: ProcedureColumn[] = [
  { key: "status", label: "Status", colSpan: 2 },
  { key: "code", label: "Code", colSpan: 1 },
  { key: "name", label: "Name", colSpan: 4 },
  { key: "insuranceFee", label: "Insurance Fee", colSpan: 2, align: "right" },
  { key: "selfPayFee", label: "Self Pay Fee", colSpan: 2, align: "right" },
  { key: "action", label: "Action", colSpan: 1, align: "right" },
];

export function getColumnConfig(key: ProcedureColumnKey): ProcedureColumn {
  const column = PROCEDURE_COLUMNS.find((col) => col.key === key);
  if (!column) throw new Error(`Unknown column key: ${key}`);
  return column;
}

/**
 * Notification id for the failed fee-schedule read.
 *
 * `toast` clears every other active notification when it is called without an id, so a
 * repeated failure would wipe unrelated messages. Reusing one id updates this notification
 * in place instead.
 */
export const FEE_SCHEDULE_LOAD_ERROR_TOAST_ID = "fee-schedule-load-error";
